import {
  X,
  FileText,
  Users,
  Pencil,
  History,
  GitBranch,
  CheckCircle2,
  Clock,
  ChevronDown,
  ChevronUp,
  User,
  Mail,
  Eye,
  Trash2,
  LucideEye,
  EyeClosed,
  ScanEye,
  RefreshCw,
  UsersRound,
  ExternalLink,
  UserRound,
  Phone,
  Clock3,
  BriefcaseBusiness,
  ChevronRight,
} from 'lucide-react';
import { useState, useEffect, useCallback } from 'react';
import DcoDetailsViewer from './doc-details-viewer';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../../Utils/toastContext';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { debounce } from 'lodash';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const dummyContract = {
  id: 'CT-10293',
  name: 'Oak Residency Lease Agreement',
  status: 'Partially Signed',
  type: 'Lease Agreement',
  version: 'v3.2',
  createdAt: '10/05/2026',
  lastUpdated: '10/05/2026',
  createdBy: 'John White (Team Member)',

  contractor: {
    name: 'Michael Smith',
    email: 'michael.smith@email.com',
  },

  content: `LEASE AGREEMENT

This Lease Agreement is made between the Landlord and Tenant.

1. Property: Oak Residency, Austin TX
2. Term: 12 Months
3. Rent: $2,500/month
4. Security Deposit: $2,500
5. Terms: Standard residential lease terms apply.

(Signatures required below)`.repeat(2),

  signers: [
    {
      name: 'Alex Johnson',
      role: 'Tenant',
      status: 'signed',
      time: '2026-06-18 10:32 AM',
      email: 'alex@email.com',
    },
    {
      name: 'Priya Patel',
      role: 'Guarantor',
      status: 'pending',
      time: null,
      email: 'rpiya@email.com',
    },
    {
      name: 'Michael Smith',
      role: 'Co-Tenant',
      status: 'pending',
      time: null,
      email: 'smith@email.com',
    },
  ],

  access: [
    { name: 'John White', role: 'Creator', email: 'john@company.com' },
    { name: 'Alex Johnson', role: 'Signer', email: 'alex@email.com' },
    { name: 'Priya Patel', role: 'Viewer', email: 'priya@email.com' },
  ],

  versions: [
    { v: 'v1.0', date: '2026-06-10', by: 'Admin' },
    { v: 'v2.0', date: '2026-06-14', by: 'Manager' },
    { v: 'v3.2', date: '2026-06-18', by: 'Auto-save' },
    { v: 'v1.0', date: '2026-06-10', by: 'Admin' },
    { v: 'v2.0', date: '2026-06-14', by: 'Manager' },
    { v: 'v3.2', date: '2026-06-18', by: 'Auto-save' },
  ],
};

const PRIMARY = '#375AE7';
export default function ContractDetailsFullScreen({
  onClose,
  onEdit,
  onAssign,
}) {
  // const contract = dummyContract;
  const [contract, setContract] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [editorContent, setEditorContent] = useState('');
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedversionPreview, setSelectedversionPreview] = useState(null);
  const [versions, setVersions] = useState([]);
  const [historyView, setHistoryView] = useState('list');
  const navigate = useNavigate();
  const { customerId, transactionId, contractId } = useParams();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedSigner, setSelectedSigner] = useState(null);
  const [agents, setAgents] = useState([]);
  const [pagination, setPagination] = useState(null);

  const [page, setPage] = useState(1);
  const [isPdfLoading, setIsPdfLoading] = useState(true);
  const location = useLocation();

  // "list" | "preview"
  const GetAPIcalls = async (url, isBlob = false) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;

    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('jwtToken');
        navigate('/login');
        throw new Error('Session expired.');
      }

      const errorData = await response.json().catch(() => ({
        message: 'Unexpected error',
      }));

      throw new Error(errorData.message);
    }

    return isBlob ? response.blob() : response.json();
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1//agency/contract-library/${contractId}`,
      );

      if (response.status == 200) {
        setContract(response.data.contract);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getAgentDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agency/contract-library/${contractId}/agents?page=${page}&page_size=10`,
      );

      if (response.status == 200) {
        setAgents(response.data.agents);
        setPagination(response.data.pagination);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getVersionDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agency/contract-library/${contractId}/versions`,
      );

      if (response.status == 200) {
        setVersions(response.data.versions);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getpdfPreview = async () => {
    try {
      const blob = await GetAPIcalls(
        `/api/v1/agency/contract-library/${contractId}/preview-pdf`,
        true,
      );

      const fileURL = URL.createObjectURL(blob);

      setPdfUrl(fileURL); // ✅ save it
      setShowModal(true); // ✅ open modal
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getSelectedVersionDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agency/contract-library/${contractId}/versions//${selectedVersion.version_number}`,
      );

      if (response.status == 200) {
        setSelectedversionPreview(response.data.version);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    const pad = (n) => String(n).padStart(2, '0');

    const formatted =
      `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

    return formatted;
  };

  const handleOpenSignerPreview = (signer) => {
    setSelectedSigner(signer);
    setModal('signer-signature');
  };
  const markDeleteAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agency/contract-library/${contractId}/archive`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleDeleteContract = async () => {
    let toastMessage = null;
    try {
      const response = await markDeleteAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        navigate('/document-management');
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const [modal, setModal] = useState(null);
  // values: "preview" | "edit" | "assign" | "history" | null
  function handleSave(content) {
    // if (selectedContract) {
    //   // EDIT EXISTING
    //   setContracts((prev) =>
    //     prev.map((c) =>
    //       c.id === selectedContract.id
    //         ? {
    //             ...c,
    //             content,
    //             status: "Draft",
    //             progress: 40,
    //             updatedAt: new Date().toISOString().slice(0, 10),
    //             history: [
    //               ...c.history,
    //               {
    //                 action: "Edited",
    //                 by: "User",
    //                 time: new Date().toISOString(),
    //               },
    //             ],
    //           }
    //         : c,
    //     ),
    //   );
    // } else {
    //   // NEW CONTRACT
    //   const newContract = {
    //     id: "c" + Date.now(),
    //     name: "New Contract",
    //     template: "Custom",
    //     content,
    //     status: "Draft",
    //     progress: 30,
    //     updatedAt: new Date().toISOString().slice(0, 10),
    //     assignedUsers: [],
    //     history: [
    //       {
    //         action: "Created",
    //         by: "User",
    //         time: new Date().toISOString(),
    //       },
    //     ],
    //   };
    //   localStorage.setItem(
    //     "contract-doc",
    //     JSON.stringify({
    //       content,
    //     }),
    //   );
    //   setContracts((prev) => [newContract, ...prev]);
    //   setSelectedContract(newContract);
    // }

    setModal(null);
    getVersionDetails();
    getAgentDetails();
    getDetails(); // Refresh contract details after save
    getpdfPreview(); // Refresh PDF preview after save
  }

  const postRevertAPI = async (versionNumber) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/agency/contract-library/${contractId}/revert`;
    const bodyData = {
      version_number: versionNumber,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postReviseAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/agency/contract-library/${contractId}/revise`;
    const bodyData = {};

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleRevokeVersion = useCallback(
    debounce(async (e, versionNumber) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseRevise = await postReviseAPI();
        if (responseRevise.status === 200) {
          const response = await postRevertAPI(versionNumber);
          if (response.status === 200) {
            showToast('Version revoked successfully', 'success');
            getDetails(); // Refresh contract details after revoking
            getVersionDetails(); // Refresh version details after revoking
            getpdfPreview(); // Refresh PDF preview after revoking
          }
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedVersion, customerId, transactionId, contractId], // Dependencies
  );
  const postAgentAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/roles/self-grant`;
    const bodyData = {
      role_id: 7, ///6 for compliance
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  // const handleRevokeVersion = async (version) => {
  //   try {
  //     // 1. Optimistic UI update
  //     // setContract((prev) => ({
  //     //   ...prev,
  //     //   versions: prev.versions.map((v) =>
  //     //     v.v === version.v
  //     //       ? {
  //     //           ...v,
  //     //           revoked: true,
  //     //           revokedAt: new Date().toISOString(),
  //     //           revokedBy: "currentUser", // replace with auth user
  //     //         }
  //     //       : v
  //     //   ),
  //     // }));

  //     // 2. API call (backend sync)
  //     const res = await fetch(`/api/contracts/${contract.id}/revoke-version`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         versionId: version.id || version.v,
  //       }),
  //     });

  //     if (!res.ok) {
  //       throw new Error("Failed to revoke version");
  //     }

  //     // 3. Optional success toast
  //     console.log("Version revoked successfully");
  //   } catch (error) {
  //     console.error(error);

  //     // 4. Rollback UI if API fails
  //     // setContract((prev) => ({
  //     //   ...prev,
  //     //   versions: prev.versions.map((v) =>
  //     //     v.v === version.v
  //     //       ? { ...v, revoked: false, revokedAt: null, revokedBy: null }
  //     //       : v
  //     //   ),
  //     // }));

  //     alert("Failed to revoke version. Please try again.");
  //   }
  // };
  useEffect(() => {
    getDetails();
    getVersionDetails();
    getpdfPreview();
  }, [contractId, transactionId, customerId]);
  useEffect(() => {
    if (selectedVersion) {
      getSelectedVersionDetails();
    }
  }, [selectedVersion]);
  useEffect(() => {
    getAgentDetails();
  }, [page]);
  console.log('selected signer', selectedSigner);
  const signatureImageUrl = (() => {
    if (!selectedSigner?.signed_fields?.length) return null;

    const signatureField = selectedSigner.signed_fields.find(
      (field) =>
        field.field_type === 'signature' &&
        field.signer_user_id === selectedSigner.user_id,
    );

    return (
      signatureField?.signature_image_url ||
      signatureField?.value || // fallback if backend changes
      null
    );
  })();

  return (
    <div className=" bg-gray-50 flex flex-col mr-4 rounded-2xl">
      {/* HEADER */}
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="sticky top-0 z-20 bg-white border-b px-4 md:px-6 py-4 flex justify-between items-center rounded-2xl">
        <div className="flex items-center gap-3">
          <FileText style={{ color: PRIMARY }} />

          <div>
            <h1 className="font-semibold text-gray-900 text-sm md:text-base">
              {contract?.title}
            </h1>
            <p className="text-xs text-gray-500">v{contract?.version_number}</p>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-4 gap-6 p-4 md:p-6 overflow-y-auto">
        {/* LEFT */}
        <div className="lg:col-span-3 space-y-5">
          {/* META */}
          <div className="bg-white rounded-xl p-4 md:p-5 shadow-sm grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            {/* <Meta label="Type" value={contract?.type} /> */}
            <Meta
              label="Created"
              value={formatDateTime(contract?.created_at)}
            />
            <Meta
              label="Updated"
              value={formatDateTime(contract?.updated_at)}
            />
            <Meta label="Status" value={contract?.status} />
          </div>

          {/* SIGNING */}
          <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
            {/* HEADER */}
            <div className="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <div className="h-9 w-9 rounded-xl bg-[#375AE7]/10 flex items-center justify-center">
                    <UserRound size={18} className="text-[#375AE7]" />
                  </div>

                  <h2 className="font-semibold text-gray-900">
                    Contract Used By
                  </h2>
                </div>

                <p className="text-sm text-gray-500 mt-2">
                  Review agents who are using this contract and track their
                  activity.
                </p>
              </div>

              <div
                className="
      px-3 py-1.5 
      rounded-full 
      bg-blue-50 
      text-blue-700 
      text-xs 
      font-medium
      w-fit
    "
              >
                {agents?.length || 0} Active Team Members
              </div>
            </div>

            {/* AGENT LIST */}
            <div className="space-y-4">
              {agents?.length === 0 ? (
                <div
                  className="
    flex
    flex-col
    items-center
    justify-center
    py-12
    px-6
    rounded-2xl
    border
    border-dashed
    border-gray-200
    bg-gray-50
    text-center
    "
                >
                  {/* ICON */}
                  <div
                    className="
      h-14
      w-14
      rounded-2xl
      bg-[#375AE7]/10
      flex
      items-center
      justify-center
      mb-4
      "
                  >
                    <UsersRound size={26} className="text-[#375AE7]" />
                  </div>

                  {/* TITLE */}
                  <h3
                    className="
      text-base
      font-semibold
      text-gray-900
      "
                  >
                    No agents found
                  </h3>

                  {/* DESCRIPTION */}
                  <p
                    className="
      mt-2
      max-w-sm
      text-sm
      text-gray-500
      "
                  >
                    This contract has not been used by any agents yet. Once an
                    agent starts using this contract, their activity will appear
                    here.
                  </p>
                </div>
              ) : (
                <>
                  {agents?.map((agent) => (
                    <div
                      key={agent.user_id}
                      className="
        group
        rounded-2xl
        border
        border-gray-100
        p-4
        hover:border-[#375AE7]/30
        hover:shadow-md
        transition-all
        "
                    >
                      {/* TOP SECTION */}
                      <div
                        className="
          flex
          flex-col
          sm:flex-row
          sm:items-center
          justify-between
          gap-4
        "
                      >
                        {/* USER INFO */}
                        <div className="flex items-center gap-3">
                          <div
                            className="
              h-12
              w-12
              rounded-full
              bg-gradient-to-br
              from-[#375AE7]
              to-[#6B8AFF]
              flex
              items-center
              justify-center
              text-white
              font-semibold
              "
                          >
                            {agent.name?.charAt(0)}
                          </div>

                          <div>
                            <h3
                              className="
                font-semibold 
                text-gray-900
                group-hover:text-[#375AE7]
                transition
              "
                            >
                              {agent.name}
                            </h3>

                            <div
                              className="
                flex
                flex-wrap
                items-center
                gap-x-4
                gap-y-1
                mt-1
                text-xs
                text-gray-500
              "
                            >
                              <span className="flex items-center gap-1">
                                <Mail size={13} />
                                {agent.email}
                              </span>

                              <span className="flex items-center gap-1">
                                <Phone size={13} />
                                {agent.country_code} {agent.mobile_number}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* LAST USED */}
                        <div
                          className="
            flex
            items-center
            gap-2
            text-xs
            text-gray-500
          "
                        >
                          <Clock3 size={15} />
                          Last used:
                          <span className="font-medium text-gray-700">
                            {new Date(agent.last_used_at).toLocaleDateString(
                              'en-AU',
                              {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                              },
                            )}
                          </span>
                        </div>
                      </div>

                      {/* STATS */}
                      <div
                        className="
          grid
          grid-cols-1
          sm:grid-cols-2
          gap-3
          mt-5
        "
                      >
                        {/* CONTRACT COUNT */}
                        <div
                          className="
            rounded-xl
            bg-blue-50
            p-3
            flex
            items-center
            gap-3
          "
                        >
                          <div
                            className="
              h-9
              w-9
              rounded-lg
              bg-blue-100
              flex
              items-center
              justify-center
            "
                          >
                            <FileText size={17} className="text-blue-600" />
                          </div>

                          <div>
                            <p className="text-xs text-gray-500">Times Used</p>

                            <p className="font-semibold text-gray-900">
                              {agent.contracts_count}
                            </p>
                          </div>
                        </div>

                        {/* DEAL COUNT */}
                        <div
                          className="
            rounded-xl
            bg-emerald-50
            p-3
            flex
            items-center
            gap-3
          "
                        >
                          <div
                            className="
              h-9
              w-9
              rounded-lg
              bg-emerald-100
              flex
              items-center
              justify-center
            "
                          >
                            <BriefcaseBusiness
                              size={17}
                              className="text-emerald-600"
                            />
                          </div>

                          <div>
                            <p className="text-xs text-gray-500">
                              Deals Created
                            </p>

                            <p className="font-semibold text-gray-900">
                              {agent.deals_count}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
              {/* PAGINATION */}

              {agents?.length > 0 && (
                <div
                  className="
    mt-6
    pt-4
    border-t
    border-gray-100
    flex
    flex-col
    sm:flex-row
    items-center
    justify-between
    gap-4
    "
                >
                  {/* RECORD INFO */}
                  <div className="text-sm text-gray-500">
                    Showing{' '}
                    <span className="font-semibold text-gray-700">
                      {(pagination.page - 1) * pagination.page_size + 1}
                    </span>{' '}
                    to{' '}
                    <span className="font-semibold text-gray-700">
                      {Math.min(
                        pagination.page * pagination.page_size,
                        pagination.total,
                      )}
                    </span>{' '}
                    of{' '}
                    <span className="font-semibold text-gray-700">
                      {pagination.total}
                    </span>{' '}
                    agents
                  </div>

                  {/* PAGINATION CONTROLS */}

                  <div className="flex items-center gap-2">
                    {/* PREVIOUS */}

                    <button
                      disabled={pagination.page === 1}
                      onClick={() => setPage((prev) => prev - 1)}
                      className="
        h-9
        px-3
        rounded-xl
        border
        border-gray-200
        bg-white
        text-sm
        font-medium
        text-gray-600
        hover:bg-gray-50
        disabled:opacity-40
        disabled:cursor-not-allowed
        transition
        "
                    >
                      Previous
                    </button>

                    {/* PAGE NUMBERS */}

                    {Array.from({
                      length: pagination.total_pages,
                    }).map((_, index) => {
                      const pageNumber = index + 1;

                      return (
                        <button
                          key={pageNumber}
                          onClick={() => setPage(pageNumber)}
                          className={`
            h-9
            min-w-9
            px-3
            rounded-xl
            text-sm
            font-semibold
            transition
            ${
              pagination.page === pageNumber
                ? 'bg-[#375AE7] text-white shadow-sm'
                : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'
            }
            `}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}

                    {/* NEXT */}

                    <button
                      disabled={pagination.page === pagination.total_pages}
                      onClick={() => setPage((prev) => prev + 1)}
                      className="
        h-9
        px-3
        rounded-xl
        border
        border-gray-200
        bg-white
        text-sm
        font-medium
        text-gray-600
        hover:bg-gray-50
        disabled:opacity-40
        disabled:cursor-not-allowed
        transition
        "
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT ACTION PANEL */}

        <div className="lg:sticky lg:top-20 h-full">
          <div
            className="
              rounded-2xl
              border
              border-slate-200
              bg-white
              p-4
              shadow-sm
              space-y-4
            "
          >
            {/* HEADER */}
            <div
              className="
                flex
                items-center
                justify-between
                border-b
                pb-3
              "
            >
              <div>
                <h3 className="text-sm font-bold text-slate-900">
                  Contract Actions
                </h3>

                <p className="text-xs text-slate-500 mt-1">
                  Manage document workflow
                </p>
              </div>
            </div>

            <div className="space-y-3">
              {/* PREVIEW */}
              <button
                onClick={() => setModal('preview')}
                className="
                    group
                    w-full
                    flex
                    items-center
                    gap-3
                    rounded-xl
                    border
                    border-slate-200
                    bg-white
                    px-4
                    py-3
                    text-sm
                    font-semibold
                    text-slate-700
                    transition
                    hover:border-blue-300
                    hover:bg-blue-50/50
                  "
              >
                <div
                  className="
                      h-9
                      w-9
                      rounded-lg
                      bg-blue-50
                      text-blue-600
                      flex
                      items-center
                      justify-center
                    "
                >
                  <Eye size={17} />
                </div>

                <span>Preview Contract</span>
              </button>

              {/* Edit Doc */}
              {contract?.status !== 'archived' && (
                <ActionButton
                  onClick={() => {
                    let path = `/edit-template/${contractId}`;
                    let redirectState = {
                      path: path,
                      state: {
                        from: location.pathname,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    };
                    sessionStorage.setItem(
                      'redirectAfterLogin',
                      JSON.stringify(redirectState),
                    );
                    navigate(path, {
                      state: {
                        from: location.pathname,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    });
                  }}
                  label="Edit Document"
                  icon={Pencil}
                />
              )}

              {/* DELETE */}
              {contract?.status !== 'archived' && (
                <ActionButton
                  onClick={() => setModal('delete')}
                  label="Delete Contract"
                  icon={Trash2}
                  danger
                />
              )}

              {contract?.status !== 'archived' && (
                <button
                  onClick={() => setModal('history')}
                  className="
                    group
                    w-full
                    flex
                    items-center
                    gap-3
                    rounded-xl
                    border
                    border-slate-200
                    bg-white
                    px-4
                    py-3
                    text-sm
                    font-semibold
                    text-slate-700
                    transition
                    hover:border-blue-300
                    hover:bg-blue-50/50
                  "
                >
                  <div
                    className="
                      h-9
                      w-9
                      rounded-lg
                      bg-blue-50
                      text-blue-600
                      flex
                      items-center
                      justify-center
                    "
                  >
                    <History size={17} />
                  </div>

                  <span>Version History</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE ACTION BAR */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t p-3 flex gap-2">
        <button onClick={onEdit} className="flex-1 py-2 rounded-lg border">
          Edit
        </button>
        <button
          onClick={onAssign}
          className="flex-1 py-2 rounded-lg text-white"
          style={{ background: PRIMARY }}
        >
          Assign
        </button>
      </div>
      {modal === 'preview' && (
        <Modal
          title={contract?.title || 'Contract preview'}
          className="max-w-6xl"
          onClose={() => setModal(null)}
        >
          <div className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                title="PDF Preview"
                width="100%"
                height="600px"
                className="rounded-xl border border-slate-200"
              />
            ) : (
              <div className="flex h-[60vh] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50 text-sm text-slate-500">
                Loading preview...
              </div>
            )}
          </div>
        </Modal>
      )}
      {modal === 'signed-preview' && (
        <Modal
          onClose={() => setModal(null)}
          className="max-w-7xl p-0 overflow-hidden rounded-3xl"
        >
          {/* 🔷 Header */}
          <div className="sticky top-0 z-10 flex items-center justify-between border-b border-slate-200 bg-white/80 backdrop-blur-xl px-6 py-4">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#EEF2FF]">
                <FileText className="text-[#375AE7]" size={18} />
              </div>
              <div>
                <h2 className="text-base font-semibold text-slate-900">
                  {contract?.title || 'Signed Contract'}
                </h2>
                <p className="text-xs text-slate-500">Secure PDF preview</p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              {pdfUrl && (
                <>
                  <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
                  >
                    <ExternalLink size={14} />
                    Open
                  </a>

                  <button
                    onClick={() => {
                      setIsPdfLoading(true);
                    }}
                    className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
                  >
                    <RefreshCw size={14} />
                    Reload
                  </button>
                </>
              )}
            </div>
          </div>

          {/* 🔷 Body */}
          <div className="relative h-[85vh] bg-gradient-to-br from-slate-50 via-white to-[#EEF2FF] p-4">
            {/* 🔄 Loader Overlay */}
            {isPdfLoading && (
              <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/70 backdrop-blur-sm">
                <div className="mb-3 h-10 w-10 animate-spin rounded-full border-2 border-[#375AE7] border-t-transparent" />
                <p className="text-sm font-medium text-slate-700">
                  Loading signed document...
                </p>
              </div>
            )}

            {/* 📄 PDF Viewer */}
            {contract?.signed_pdf_url ? (
              <div className="h-full w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <iframe
                  src={contract?.signed_pdf_url}
                  title="Signed PDF"
                  className="h-full w-full"
                  onLoad={() => setIsPdfLoading(false)}
                />
              </div>
            ) : (
              <div className="flex h-full items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white/60">
                <p className="text-sm text-slate-500">
                  No signed document available
                </p>
              </div>
            )}
          </div>
        </Modal>
      )}
      {modal === 'signer-signature' && (
        <Modal
          title={
            selectedSigner
              ? `${selectedSigner.name} • Signature`
              : 'Signature preview'
          }
          className="max-w-4xl"
          onClose={() => setModal(null)}
        >
          <div className="space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 shadow-sm">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm font-semibold text-slate-900">
                    {selectedSigner?.name || 'Signer'}
                  </p>
                  <p className="text-sm text-slate-500">
                    {selectedSigner?.role || 'Signer'}
                  </p>
                </div>
                <div className="flex items-center gap-2 text-sm text-slate-600">
                  <span className="rounded-full border border-slate-200 bg-white px-3 py-1 font-medium">
                    {selectedSigner?.signed_at
                      ? 'Signed'
                      : selectedSigner?.viewed_at
                        ? 'Viewed'
                        : 'Pending'}
                  </span>
                  {selectedSigner?.signed_at && (
                    <span className="text-xs text-slate-400">
                      {formatDateTime(selectedSigner.signed_at)}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {signatureImageUrl ? (
              <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm">
                <img
                  src={signatureImageUrl}
                  alt={`${selectedSigner?.name || 'Signer'} signature`}
                  className="mx-auto max-h-[60vh] w-full max-w-[520px] rounded-2xl border border-slate-200 object-contain bg-slate-50 p-4"
                />
              </div>
            ) : (
              <div className="flex min-h-[48vh] flex-col items-center justify-center rounded-[24px] border border-dashed border-slate-200 bg-slate-50 px-6 text-center">
                <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-sm">
                  <Eye size={22} className="text-[#375AE7]" />
                </div>
                <p className="text-base font-semibold text-slate-900">
                  No signature image available yet
                </p>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-500">
                  This signer has not uploaded or shared a signature image for
                  this contract yet.
                </p>
              </div>
            )}
          </div>
        </Modal>
      )}

      {modal === 'delete' && (
        <Modal
          title="Delete Contract"
          className="max-w-lg"
          onClose={() => setModal(null)}
        >
          <div className="space-y-6">
            {/* Warning Icon */}
            <div className="flex items-center justify-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                <svg
                  className="h-8 w-8 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v3m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                  />
                </svg>
              </div>
            </div>

            {/* Content */}
            <div className="text-center space-y-2">
              <h3 className="text-lg font-semibold text-gray-900">
                Are you sure you want to delete this contract?
              </h3>

              <p className="text-sm text-gray-600">
                This action cannot be undone. The contract will be permanently
                removed.
              </p>

              <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4 text-left">
                <p className="text-sm font-medium text-gray-900">
                  {contract.title}
                </p>

                {contract.created_at && (
                  <p className="mt-1 text-xs text-gray-500">
                    Created at: {formatDateTime(contract.created_at)}
                  </p>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-center gap-3 pt-2">
              <button
                onClick={() => setModal(null)}
                className="
            rounded-xl 
            border 
            border-gray-300 
            px-5 
            py-2.5 
            text-sm 
            font-medium 
            text-gray-700
            hover:bg-gray-50
            transition
          "
              >
                Cancel
              </button>

              <button
                onClick={() => handleDeleteContract()}
                className="
            rounded-xl
            bg-red-600
            px-5
            py-2.5
            text-sm
            font-semibold
            text-white
            shadow-sm
            hover:bg-red-700
            transition
          "
              >
                Delete Contract
              </button>
            </div>
          </div>
        </Modal>
      )}
      {/* {showModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      
      <button onClick={() => setShowModal(false)}>Close</button>

      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="PDF Preview"
          width="100%"
          height="600px"
        />
      )}

    </div>
  </div>
)} */}
      {modal === 'history' && (
        <Modal
          title={
            historyView === 'list'
              ? 'Version History'
              : `Version: ${selectedversionPreview?.version_number}`
          }
          onClose={() => {
            setModal(null);
            setHistoryView('list');
            setSelectedVersion(null);
          }}
          size="md"
        >
          {/* HEADER ACTIONS */}

          {/* LIST VIEW */}
          {historyView === 'list' && (
            <div className="space-y-2 max-h-[65vh] overflow-y-auto pr-1">
              {versions.map((v, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between border rounded-xl p-3 hover:bg-slate-50 transition"
                >
                  <div>
                    <p className="font-medium text-slate-800">
                      <span className="font-normal text-slate-500">
                        Version Number:
                      </span>{' '}
                      {v.version_number}
                    </p>
                    <div className="flex gap-2 text-xs text-slate-500 mt-1">
                      <span>{formatDateTime(v.created_at)}</span>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      setSelectedVersion(v);
                      setHistoryView('preview');
                    }}
                    className="px-3 py-1.5 text-xs rounded-lg bg-slate-900 text-white hover:bg-slate-700 transition"
                  >
                    View
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* PREVIEW VIEW */}
          {historyView === 'preview' &&
            selectedVersion &&
            selectedversionPreview && (
              <div className="flex flex-col h-[65vh]">
                {/* META BAR */}
                <div className="flex items-center justify-between mb-3">
                  {/* LEFT: DATE (LAST UPDATED) */}
                  <div className="flex items-center gap-2">
                    <span className="text-[10px] px-2 py-1 rounded-full bg-blue-50 text-blue-600 font-medium">
                      Last updated
                    </span>

                    <span className="text-xs text-slate-700 font-medium">
                      {formatDateTime(selectedversionPreview.created_at)}
                    </span>
                  </div>
                </div>

                {/* CONTENT */}
                <div className="flex-1 border rounded-lg bg-slate-50 overflow-auto p-4">
                  <DcoDetailsViewer
                    version={selectedversionPreview.version_number}
                    contract={selectedversionPreview.document_content}
                  />
                </div>

                {/* ACTION FOOTER (STICKY UX STYLE) */}
                <div className="flex items-center justify-between mt-3 pt-3 border-t">
                  {/* LEFT: BACK */}
                  <button
                    onClick={() => setHistoryView('list')}
                    className="text-xs px-3 py-1.5 rounded-lg border bg-white hover:bg-slate-50 transition"
                  >
                    ← Back
                  </button>

                  {/* RIGHT: ACTIONS */}
                  <div className="flex gap-2">
                    {/* REVOKE BUTTON (DANGER) */}
                    <button
                      onClick={(e) => {
                        handleRevokeVersion(
                          e,
                          selectedversionPreview.version_number,
                        );
                        setHistoryView('list');
                        setSelectedVersion(null);
                      }}
                      className="px-3 py-1.5 text-xs rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                    >
                      Revoke Version
                    </button>
                  </div>
                </div>
              </div>
            )}
        </Modal>
      )}
    </div>
  );
}

/* HELPERS */
function Modal({ title, children, onClose, className = '' }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className={`
          bg-white rounded-xl shadow-xl w-full max-w-4xl h-[80vh] flex flex-col
          ${className}
        `}
      >
        {/* Header (fixed) */}
        <div className="flex justify-between items-center p-4 border-b shrink-0">
          <h2 className="font-semibold">{title}</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Body (scrollable) */}
        <div className="p-4 flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
function Meta({ label, value }) {
  const getStatusStyle = (status) => {
    const normalized = String(status || '').toLowerCase();

    if (
      ['completed', 'complete', 'published', 'approved', 'active'].includes(
        normalized,
      )
    ) {
      return {
        className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
        dot: 'bg-emerald-500',
      };
    }

    if (['pending', 'draft', 'waiting', 'sent'].includes(normalized)) {
      return {
        className: 'bg-amber-50 text-amber-700 border-amber-200',
        dot: 'bg-amber-500',
      };
    }

    if (['rejected', 'cancelled', 'failed', 'archived'].includes(normalized)) {
      return {
        className: 'bg-grey-50 text-gray-600 border-grey-200',
        dot: 'bg-gray-500',
      };
    }

    if (['review', 'under_review', 'in progress'].includes(normalized)) {
      return {
        className: 'bg-blue-50 text-blue-700 border-blue-200',
        dot: 'bg-blue-500',
      };
    }

    return {
      className: 'bg-slate-50 text-slate-700 border-slate-200',
      dot: 'bg-slate-400',
    };
  };

  const isStatus = label?.toLowerCase() === 'status';

  const statusStyle = isStatus ? getStatusStyle(value) : null;

  return (
    <div className="space-y-1.5">
      <div className="text-gray-400 text-xs font-medium uppercase tracking-wide">
        {label}
      </div>

      {isStatus ? (
        <div
          className={`
            inline-flex
            items-center
            gap-2
            rounded-full
            border
            px-3
            py-1
            text-xs
            font-semibold
            capitalize
            ${statusStyle.className}
          `}
        >
          <span
            className={`
              h-2
              w-2
              rounded-full
              ${statusStyle.dot}
            `}
          />

          {value || 'Unknown'}
        </div>
      ) : (
        <div className="font-semibold text-gray-800">{value || '-'}</div>
      )}
    </div>
  );
}

function ActionButton({ label, icon: Icon, onClick, danger, success }) {
  return (
    <button
      onClick={onClick}
      className={`
        w-full
        flex
        items-center
        gap-3
        rounded-xl
        px-4
        py-3
        text-sm
        font-semibold
        transition

        ${
          danger
            ? 'border border-red-200 bg-red-50 text-red-700 hover:bg-red-100'
            : success
              ? 'border border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
              : 'border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-blue-300'
        }
      `}
    >
      <div
        className="
          h-9
          w-9
          rounded-lg
          bg-white
          shadow-sm
          flex
          items-center
          justify-center
        "
      >
        <Icon size={17} />
      </div>

      {label}
    </button>
  );
}
